export enum ConversationMessageStatusEnum {
  Sent = 'SENT',
  Seen = 'SEEN',
}
